type EmwTheme = {
  [key: string]: string | null | undefined | boolean | number
  accent?: string | null
  text?: string | null
  background?: string | null
  text_light?: string | null
  text_medium?: string | null
  text_medium_plus?: string | null
  accent_light?: string | null
  accent_contrast?: string | null
}

const updateTheme = (theme: EmwTheme) => {
  const accent = theme["accent"]
  const text = theme["text"]
  const background = theme["background"]
  const text_light = theme["text_light"]
  const text_medium = theme["text_medium"]
  const text_medium_plus = theme["text_medium_plus"]
  const accent_light = theme["accent_light"]
  const accent_contrast = theme["accent_contrast"]

  // text
  document.documentElement.style.setProperty(`--theme_text`, String(text))
  document.documentElement.style.setProperty(
    `--theme_text_light`,
    String(text_light)
  )
  document.documentElement.style.setProperty(
    `--theme_text_medium`,
    String(text_medium)
  )
  document.documentElement.style.setProperty(
    `--theme_text_medium_plus`,
    String(text_medium_plus)
  )

  // accent
  document.documentElement.style.setProperty(`--theme_accent`, String(accent))
  document.documentElement.style.setProperty(
    `--theme_accent_light`,
    String(accent_light)
  )
  document.documentElement.style.setProperty(
    `--theme_accent_contrast`,
    String(accent_contrast)
  )

  // background
  document.documentElement.style.setProperty(
    `--theme_background`,
    String(background)
  )
}
export { updateTheme }
